import {
  deriveInternationalMobileDraft,
  resolveInternationalMobile,
} from '@/lib/phone/resolveInternationalMobile';

export interface ResolvedCoursePurchasePhone {
  readonly legacyPhone: string;
  readonly phoneDetails: Readonly<{
    e164: string;
    country: string;
  }>;
}

export interface CoursePurchasePhoneInitialValue {
  readonly country: string;
  readonly phone: string;
}

interface CoursePurchasePhoneDraft {
  country: string;
  phone?: string | null;
}

function resolvedPhone(
  e164: string,
  country: string,
): ResolvedCoursePurchasePhone {
  const phoneDetails = Object.freeze({ e164, country });
  return Object.freeze({ legacyPhone: e164, phoneDetails });
}

export function resolveCoursePurchasePhone({
  country,
  phone,
}: CoursePurchasePhoneDraft): ResolvedCoursePurchasePhone | null {
  const resolved = resolveInternationalMobile({ country, phone });
  if (!resolved) return null;

  return resolvedPhone(resolved.e164, resolved.country);
}

export function deriveCoursePurchasePhoneInitialValue(
  profilePhone?: string | null,
): CoursePurchasePhoneInitialValue {
  const draft = deriveInternationalMobileDraft(profilePhone);
  return Object.freeze({ country: draft.country, phone: draft.phone });
}
